import { createGlobalStyle } from './styled-components'
import reset from './reset';

export default createGlobalStyle`
  ${reset}

  *, *::after, *::before {
    box-sizing: border-box
  }

  body {
    position: relative;
    font-family: 'Roboto', 'Roboto-Bold', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.4;
  }
  #root {
    margin: 0;
    height: 100%;
  }
  b, strong {
    font-weight: bold;
  }
  a {
    color: ${({ theme }) => theme.linkColorCommon};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
    &[disabled] {
      pointer-events: none;
      opacity: 0.5;
    }
  }
  button {
    background: none;
    border: 0;
    padding: 0;
    margin: 0;
    cursor: pointer;
    font-family: inherit;
    outline: none;

    &[disabled] {
      cursor: default;
    }
  }
  input {
    font-size: inherit;
    font-family: inherit;
    padding: 0;
    border: 0px;
    margin: 0px;
  }
  .hidden {
    visibility: hidden;
  }
  /* other styles */
`
